import { useState } from "react";
import { AppointmentCalendar } from "./AppointmentCalendar.js";
import { TimeSlotSelector } from "./TimeSlotSelector.js";
import { apiPost } from "../../client/apiClient.js";
import type { ApiResult, BookingSlot } from "../../shared/types.js";
import { ValidationMessage } from "../../components/States.js";

export function DateTimeStep({
  slot,
  holdId,
  onSlotChange,
  onHoldChange,
  postalCode,
}: {
  slot: BookingSlot | null;
  holdId: string | null;
  onSlotChange: (slot: BookingSlot | null) => void;
  onHoldChange: (holdId: string | null) => void;
  postalCode?: string;
}) {
  const [error, setError] = useState<string | null>(null);
  const [holding, setHolding] = useState(false);

  async function releasePrevious() {
    if (holdId) {
      try {
        await apiPost("/api/booking/release-hold", { holdId });
      } catch {
        /* best-effort: verlopen holds ruimen ook automatisch server-side op */
      }
    }
  }

  async function selectDate(date: string) {
    await releasePrevious();
    onHoldChange(null);
    onSlotChange({ date, time: "" });
    setError(null);
  }

  async function selectTime(time: string) {
    if (!slot) return;
    setHolding(true);
    setError(null);
    await releasePrevious();
    try {
      const res = (await apiPost("/api/booking/hold", { date: slot.date, time })) as ApiResult<{ holdId: string }>;
      if (res.ok) {
        onSlotChange({ date: slot.date, time });
        onHoldChange(res.data.holdId);
      } else {
        setError(res.error);
      }
    } catch {
      setError("Kon dit tijdslot niet reserveren. Probeer een ander moment.");
    } finally {
      setHolding(false);
    }
  }

  return (
    <div>
      <h2>Kies een datum en tijd</h2>
      <p className="text-small text-muted">Beschikbare data in uw regio.</p>
      <div className="grid grid-2">
        <AppointmentCalendar selectedDate={slot?.date ?? null} onSelectDate={selectDate} postalCode={postalCode} />
        <div>
          {slot?.date ? (
            <TimeSlotSelector date={slot.date} selectedTime={slot.time || null} onSelectTime={selectTime} postalCode={postalCode} />
          ) : (
            <p className="text-small text-muted">Kies eerst een datum in de kalender.</p>
          )}
          {holding && <p className="text-small">Tijdslot wordt gereserveerd…</p>}
          <ValidationMessage>{error}</ValidationMessage>
          {slot?.time && !error && (
            <p className="form-success-message mt-4">
              Tijdslot gereserveerd tot u de boeking bevestigt (10 minuten).
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
